import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { Env } from '@contexts/AppContext';
import useEventTracking from '@hooks/useEventTracking';
import { Page } from '@tracking';
import { BookmarkContent } from '@utils/backend-api/bookmarks';
import { User } from '@utils/backend-api/currentUser';

import PageContainer from '../Highlight/PageContainer';
import Content from './Content';

const queryClient = new QueryClient();

interface BookmarkProps {
  bookmarks: BookmarkContent;
  env: Env;
  initialCurrentUser?: User;
  isNativeApp?: boolean;
  isWebview: boolean;
  nativeAppVersion?: string;
  showBookmarksFlagEnabled?: boolean;
}

const Bookmarks = ({
  bookmarks,
  env,
  initialCurrentUser,
  isNativeApp,
  isWebview,
  nativeAppVersion,
  showBookmarksFlagEnabled,
}: BookmarkProps) => {
  const { Track } = useEventTracking({
    page: Page.Bookmarks,
  });

  return (
    <QueryClientProvider client={queryClient}>
      <Track>
        <PageContainer
          env={env}
          initialCurrentUser={initialCurrentUser}
          isNativeApp={isNativeApp}
          isWebview={isWebview}
          nativeAppVersion={nativeAppVersion}
          showBookmarksFlagEnabled={showBookmarksFlagEnabled}
        >
          <Content
            bookmarks={bookmarks.content}
            page={bookmarks.page}
            per_page={bookmarks.per_page}
            total_pages={bookmarks.total_pages}
          />
        </PageContainer>
      </Track>
    </QueryClientProvider>
  );
};

export default Bookmarks;
